import axios from '@/axios'

const state = {
  loading: false
};

const actions = {
  async line({commit}, payload) {
    try {
      commit('LOADING', true);
      const {data} = await axios.post('admin/badadv/chart/date',payload);
      return  data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING', false);
    }
  }
}

const mutations = {
  LOADING(state, payload) {
    state.loading = payload;
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
